import React from "react";
import logo from "../images/logo.png";
import "./LeftSide.css";

const LeftSide = () => {
  return (
    <div className="flex-1 content-left">
      <div className="content-left-wrapper">
        <div className="wrapper">
          <span id="logo">
            <img src={logo} alt="Logo" />
          </span>
          <div className="title">
            <h1>Book a Table</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
